import styles from "./SelectCustom.module.scss";

function SelectCustom({
  value,
  onChange,
  options = [],
  placeholder,
  style,
  className,
  disabled = false,
  valueProp = "value",
  labelProp = "label",
  minWidth,
  initialValue,
  ...rest // autres props valides pour <select>
}) {
  const currentValue = value ?? initialValue ?? "";

  return (
    <select
      className={`${styles.select} ${className || ""}`}
      value={currentValue}
      onChange={onChange}
      style={{ minWidth, ...style }}
      disabled={disabled}
      {...rest}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((option) => {
        const optValue =
          typeof option === "object" ? option[valueProp] : option;
        const optLabel =
          typeof option === "object" ? option[labelProp] : option;

        // optValue peut être undefined/null → fallback sur une valeur stable
        const key =
          optValue != null ? String(optValue) : JSON.stringify(option);

        return (
          <option key={key} value={optValue}>
            {optLabel}
          </option>
        );
      })}
    </select>
  );
}

export default SelectCustom;
